<template>
    <div class="search">
        <div class="Header">
            <form action="/">
                <van-search
                    v-model="value"
                    placeholder="输入品牌或关键字进行搜索"
                    show-action
                    background="#fff"
                    @search="onSearch"
                    @cancel="onCancel"
                />
            </form>
        </div>
        <hotSearch v-on:accestKey="accestKeys"/>
        <historySearch v-on:deleHis="deleHis"/>
    </div>
</template>

<script>
import { searchModel } from "@/api/search";
import hotSearch from "@/components/hotSearch.vue";
import historySearch from "@/components/historySearch.vue";
import { Search } from "vant";
import { searchHistory, GetHistory } from '@/utils/storage';
export default {
  data() {
    return {
      value: '',
      searchList: []
    }
  },
  components: {
    hotSearch,
    historySearch,
    [Search.name]: Search
  },
  created () {
    alert
    this.searchList = GetHistory('searchHistory') || []
  },
  methods: {
    deleHis () {
      this.searchList = []
    },
    // assect 
    accestKeys (key) {
      this.value = key
      this.onSearch()
    },
    onCancel () {
      this.$router.go(-1)
    },
    onSearch () {
      // 添加搜索历史
      let category = this.$route.query.category;
      this.searchList.unshift(this.value)
      this.$store.dispatch('ChangeVmSearch', this.searchList)
      searchHistory ('searchHistory', this.searchList.slice(0, 8))
      searchModel({like: this.value, category: category}).then(res => {
        // 跳转
        this.$router.push({
          path: '/searchResult',
          query: {
            name: '搜索结果',
            result: res
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped lang="less">
.search {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    .Header {
        width: 100%;
        height: auto;
        border-bottom: 1px solid rgba(225,225,225,1);
        form {
          position: relative;
          &>i {
            position: absolute;
            right: 20%;
            top: 35%;
          }
        }
        /deep/ .van-cell {
            background: rgba(242,244,244,1);
            border-radius: 0px;
        }
        /deep/ input {
            color: rgba(206,208,208,1);
            font-weight: 400;
            font-size:13px;
        }
        /deep/ .van-search__action {
            color:rgba(0,0,0,1);
            font-size:16px;
            font-weight: 400;
            padding-left: 18px;
        }
        /deep/ .van-search {
            color:rgba(0,0,0,1);
            font-size:16px;
            font-weight: 400;
            padding-left: 20px;
            padding-right: 8px; 
        }
    }
}
</style>
